var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	18551: {
		fallback: ()=>()=>{throw new Error("Can not get 'react'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	73362: {
		fallback: ()=>()=>{throw new Error("Can not get 'react-dom'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	40596: {
		fallback: () => (Promise.all([__webpack_require__.e(4786), __webpack_require__.e(5281), __webpack_require__.e(7757), __webpack_require__.e(1611), __webpack_require__.e(1902), __webpack_require__.e(5029), __webpack_require__.e(5059), __webpack_require__.e(5302), __webpack_require__.e(4482), __webpack_require__.e(7732), __webpack_require__.e(3760), __webpack_require__.e(2019), __webpack_require__.e(5132), __webpack_require__.e(299), __webpack_require__.e(6553), __webpack_require__.e(1860), __webpack_require__.e(2717), __webpack_require__.e(2008), __webpack_require__.e(6275), __webpack_require__.e(807), __webpack_require__.e(3110), __webpack_require__.e(7460), __webpack_require__.e(8099), __webpack_require__.e(8062)]).then(() => (() => (__webpack_require__(49145))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "history",

	},
	70546: {
		fallback: () => (Promise.all([__webpack_require__.e(8853), __webpack_require__.e(1454), __webpack_require__.e(9119), __webpack_require__.e(5921), __webpack_require__.e(3081), __webpack_require__.e(6426), __webpack_require__.e(8491), __webpack_require__.e(5350)]).then(() => (() => (__webpack_require__(48064))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "graphql",

	},
	81079: {
		fallback: () => (Promise.all([__webpack_require__.e(4786), __webpack_require__.e(8853), __webpack_require__.e(1454), __webpack_require__.e(9119), __webpack_require__.e(5921), __webpack_require__.e(3081), __webpack_require__.e(6426), __webpack_require__.e(8491), __webpack_require__.e(5350), __webpack_require__.e(1051), __webpack_require__.e(5324), __webpack_require__.e(1155), __webpack_require__.e(5472), __webpack_require__.e(1360), __webpack_require__.e(7167), __webpack_require__.e(5468), __webpack_require__.e(238), __webpack_require__.e(6055), __webpack_require__.e(5281), __webpack_require__.e(7757), __webpack_require__.e(1611), __webpack_require__.e(1902), __webpack_require__.e(5029), __webpack_require__.e(5059), __webpack_require__.e(5302), __webpack_require__.e(4482), __webpack_require__.e(7732), __webpack_require__.e(3760), __webpack_require__.e(2019), __webpack_require__.e(5132), __webpack_require__.e(299), __webpack_require__.e(6553), __webpack_require__.e(1860), __webpack_require__.e(2717), __webpack_require__.e(2008), __webpack_require__.e(6275), __webpack_require__.e(807), __webpack_require__.e(3110), __webpack_require__.e(7460), __webpack_require__.e(8099), __webpack_require__.e(8062), __webpack_require__.e(596), __webpack_require__.e(9538)]).then(() => (() => (__webpack_require__(6211))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@agendrix/design-system",

	},
	30005: {
		fallback: () => (Promise.all([__webpack_require__.e(8853), __webpack_require__.e(1454), __webpack_require__.e(9119), __webpack_require__.e(5921), __webpack_require__.e(3081), __webpack_require__.e(6426), __webpack_require__.e(8491), __webpack_require__.e(5350), __webpack_require__.e(5281), __webpack_require__.e(7757), __webpack_require__.e(1611), __webpack_require__.e(1902), __webpack_require__.e(5029), __webpack_require__.e(5059), __webpack_require__.e(5302), __webpack_require__.e(4482), __webpack_require__.e(7732), __webpack_require__.e(3760), __webpack_require__.e(2019), __webpack_require__.e(5132), __webpack_require__.e(299), __webpack_require__.e(6553), __webpack_require__.e(1860), __webpack_require__.e(2717), __webpack_require__.e(2008), __webpack_require__.e(6275), __webpack_require__.e(807), __webpack_require__.e(3110), __webpack_require__.e(7460), __webpack_require__.e(8099), __webpack_require__.e(8062)]).then(() => (() => (__webpack_require__(44224))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@apollo/client",

	},
	85836: {
		fallback: ()=>()=>{throw new Error("Can not get '@azure/msal-browser'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@azure/msal-browser",

	},
	40347: {
		fallback: ()=>()=>{throw new Error("Can not get '@azure/msal-react'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@azure/msal-react",

	},
	1962: {
		fallback: () => (Promise.all([__webpack_require__.e(5281), __webpack_require__.e(7757), __webpack_require__.e(1611), __webpack_require__.e(1902), __webpack_require__.e(5029), __webpack_require__.e(5059), __webpack_require__.e(5302), __webpack_require__.e(4482), __webpack_require__.e(7732), __webpack_require__.e(3760), __webpack_require__.e(2019), __webpack_require__.e(5132), __webpack_require__.e(299), __webpack_require__.e(6553), __webpack_require__.e(1860), __webpack_require__.e(2717), __webpack_require__.e(2008), __webpack_require__.e(6275), __webpack_require__.e(807), __webpack_require__.e(3110), __webpack_require__.e(7460), __webpack_require__.e(8099), __webpack_require__.e(8062)]).then(() => (() => (__webpack_require__(54449))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@microsoft/applicationinsights-react-js",

	},
	28041: {
		fallback: () => (Promise.all([__webpack_require__.e(5281), __webpack_require__.e(7757), __webpack_require__.e(1611), __webpack_require__.e(1902), __webpack_require__.e(5029), __webpack_require__.e(5059), __webpack_require__.e(5302), __webpack_require__.e(4482), __webpack_require__.e(7732), __webpack_require__.e(3760), __webpack_require__.e(2019), __webpack_require__.e(5132), __webpack_require__.e(299), __webpack_require__.e(6553), __webpack_require__.e(1860), __webpack_require__.e(2717), __webpack_require__.e(2008), __webpack_require__.e(6275), __webpack_require__.e(807), __webpack_require__.e(3110), __webpack_require__.e(7460), __webpack_require__.e(8099), __webpack_require__.e(8062)]).then(() => (() => (__webpack_require__(18437))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@microsoft/applicationinsights-web",

	},
	1286: {
		fallback: ()=>()=>{throw new Error("Can not get '@reduxjs/toolkit'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@reduxjs/toolkit",

	},
	98098: {
		fallback: ()=>()=>{throw new Error("Can not get '@unity/auth-lib'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@unity/auth-lib",

	},
	44498: {
		fallback: () => (__webpack_require__.e(4786).then(() => (() => (__webpack_require__(86107))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "history",

	},
	12727: {
		fallback: ()=>()=>{throw new Error("Can not get 'i18next'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",

	},
	41156: {
		fallback: ()=>()=>{throw new Error("Can not get 'react-redux'")},
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-redux",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"546": [
		70546
	],
	"596": [
		40596
	],
	"2272": [
		81079,
		30005,
		85836,
		40347,
		1962,
		28041,
		1286,
		98098,
		44498,
		12727,
		41156
	],
	"3362": [
		73362
	],
	"8551": [
		18551
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}